module.exports = __webpack_public_path__ + "fonts/trust_sans_black-webfont.53402ef5.woff2";